import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import HeroBanner from './components/HeroBanner';
import AchievementShowcase from './components/AchievementShowcase';
import ModuleOverview from './components/ModuleOverview';
import Footer from './components/Footer';
import BackgroundDecorations from '@/components/feature/BackgroundDecorations';
import { achievements } from '@/mocks/achievements';
import SubNavbar from './components/SubNavbar';

export default function Home() {
  const mainAchievement = achievements[0];

  return (
    <div className="min-h-screen bg-background-50 relative">
      <main>
        <Navbar isInline />
        <HeroBanner />
        <SubNavbar isInline />
        {mainAchievement && <AchievementShowcase achievement={mainAchievement} />}
        {mainAchievement && <ModuleOverview achievement={mainAchievement} />}
      </main>
      <Footer />
      <BackgroundDecorations variant="home" />
    </div>
  );
}